<span class="timestamp">{{activity.Timestamp|cDate:'':'medium'}}</span>{{activity.User|cUserDescription:activity.Impersonator}}{{"activityLog.byUser"|translate}}
